import React from 'react';
import { bool, func } from 'prop-types';

import SecurePassword from '@assets/Image/svg/update-password/securePassword';
import ModalVerification from '@screens/Profile/components/ModalVerification';

import { PopUpCenterV2 } from 'Component/PopUp';
import { ButtonV2 } from 'Component/Ajaib';
import { styText, styBtnWrapper, styBtnWidth } from '../style';

const PasswordReminder = ({
  isOpenModal,
  isOpenVerification,
  handleNextClose,
  handleUpdateEmail,
  handleOpenVerification,
}) => (
  <div>
    <PopUpCenterV2
      show={isOpenModal}
      title="Tingkatkan Keamanan Akunmu"
      width="540px"
      closeButton={false}
    >
      <SecurePassword />
      <span className={styText}>
        Agar keamananmu terjaga, kamu perlu mengubah password secara berkala.
      </span>
      <div className={styBtnWrapper}>
        <ButtonV2
          variant="tertiary"
          onClick={handleNextClose}
          className={styBtnWidth}
        >
          Nanti Saja
        </ButtonV2>
        <ButtonV2
          variant="primary"
          className={styBtnWidth}
          onClick={handleUpdateEmail}
        >
          Update
        </ButtonV2>
      </div>
    </PopUpCenterV2>
    <ModalVerification
      show={isOpenVerification}
      handleHideModal={handleOpenVerification}
    />
  </div>
);

PasswordReminder.propTypes = {
  isOpenModal: bool,
  isOpenVerification: bool,
  handleNextClose: func,
  handleUpdateEmail: func,
  handleOpenVerification: func,
};

PasswordReminder.defaultProps = {
  isOpenModal: false,
  isOpenVerification: false,
  handleNextClose: () => {},
  handleUpdateEmail: () => {},
  handleOpenVerification: () => {},
};

export default PasswordReminder;
